import Vue from 'vue'
Vue.prototype.$appEnvironment = window.location.origin === "https://portal.snapsuite.io" ? "production" : "development";
Vue.prototype.$isDev = Vue.prototype.$appEnvironment === "development";

export const isDev = () => {
  return Vue.prototype.$isDev
}

export default { isDev }